import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";
import { getApiErrorStatus } from "../../lib/api/apiError";

export const ORDER_PURCHASE_PURPOSE = "order.purchase";

export const fetchPaymentMethods = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.methods);

  return data?.paymentMethods || data?.content || (Array.isArray(data) ? data : []);
};

export const initPaystackPayment = async (payload) => {
  const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.paystack, {
    ...payload,
    purpose: ORDER_PURCHASE_PURPOSE,
  });

  return data;
};

export const fetchPaystackStatus = async (reference) => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.paystackByReference(reference));

  return data;
};

export const fetchSavedAuthorizations = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.savedAuthorizations);

  return data;
};

export const createCodTransaction = async (payload) => {
  try {
    const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.cod, {
      ...payload,
      purpose: ORDER_PURCHASE_PURPOSE,
    });

    return data;
  } catch (err) {
    if (getApiErrorStatus(err) !== 400) throw err;

    const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.cod, payload);

    return data;
  }
};

export const fetchWalletBalance = async (currencyCode) => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.walletByCurrency(currencyCode));

  return data;
};

export const fetchWallets = async () => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.wallet);

  return data;
};

const rejectsReturnUrl = (error) =>
  getApiErrorStatus(error) === 400 &&
  JSON.stringify(error?.response?.data ?? "").includes("returnUrl");

export const initiateWalletTopUp = async ({ walletId, amount, returnUrl }) => {
  const body = { walletId, amount };

  if (!returnUrl) {
    const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.walletTopUpInitiate, body);

    return data;
  }

  try {
    const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.walletTopUpInitiate, {
      ...body,
      returnUrl,
    });

    return data;
  } catch (err) {
    if (!rejectsReturnUrl(err)) throw err;

    const { data } = await CLIENT.post(ENDPOINTS.PAYMENTS.walletTopUpInitiate, body);

    return data;
  }
};

export const fetchWalletTopUpStatus = async (reference) => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.walletTopUpCallback, {
    params: { reference },
  });

  return data;
};

export const fetchFxQuote = async ({ from, to, amount }) => {
  const { data } = await CLIENT.get(ENDPOINTS.PAYMENTS.fxQuote, {
    params: { from, to, ...(amount !== undefined ? { amount } : {}) },
  });

  return data;
};
